// ============================================================================
// PUBLIC, token-gated check-in API (the client-facing half of QR check-in).
// ----------------------------------------------------------------------------
// A trainer mints a token via sessionsApi.checkinQr() and encodes the public
// URL (/checkin/<token>) into a QR code. The client scans it IN PERSON and
// confirms arrival here — NO login required: possession of the unguessable
// token is the authorization (see viccofitness/api/checkin.py).
//
// These calls still ride through the shared /api base (`credentials:"include"`
// is harmless on a no-auth realm); the token in the path is the only secret.
// GET returns minimal PII (first name + time + trainer/location); a bad/unknown
// token yields a flat 404 (surfaced as ApiError(404)).
// ============================================================================
import { http } from "./http";
import type {
  CheckinInput,
  PublicCheckinConfirm,
  PublicCheckinView,
} from "./types";

export const checkinApi = {
  /** Minimal, safe session info for a valid token (ApiError 404 if invalid). */
  info: (token: string, signal?: AbortSignal) =>
    http.get<PublicCheckinView>(
      `/checkin/${encodeURIComponent(token)}`,
      undefined,
      signal,
    ),
  /** Confirm arrival for the session owning this token (marks attended). */
  confirm: (token: string, body: CheckinInput = {}) =>
    http.post<PublicCheckinConfirm>(
      `/checkin/${encodeURIComponent(token)}`,
      body,
    ),
};
